// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-content {
  background-color: #f5f7fa;
  min-height: 144px;
  max-height: calc(100vh - 140px);
  position: relative;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-content .semi-modal-header {
  margin-bottom: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-content .semi-modal-body {
  padding: 16px 0;
  overflow: auto;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-content .semi-modal-body.semi-modal-withIcon {
  margin-left: unset;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-header .semi-button-with-icon-only {
  border-radius: 4px;
  height: 24px;
  padding: 4px !important;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-header .semi-button-with-icon-only svg {
  width: 16px;
  height: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-header .semi-button-with-icon-only.semi-button-borderless:not(.semi-button-disabled):hover {
  background: var(--light-usage-fill-color-fill-1, rgba(46, 46, 56, .08));
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8 .semi-modal-header .semi-button-with-icon-only.semi-button-borderless:not(.semi-button-disabled):active {
  background: var(--light-usage-fill-color-fill-2, rgba(46, 46, 56, .12));
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8:not(.\\------packages-components-bot-semi-src-components-ui-modal-index-module__show-scroll-bar-qdZHF3) .semi-modal-body::-webkit-scrollbar {
  display: none;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-info-Q2RrEL .semi-modal {
  width: 446px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-small-KXyMue .semi-modal {
  width: 560px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-zRcsjo .semi-modal {
  width: 794px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-base-composition-HCwui9 .semi-modal {
  width: 1138px;
  height: calc(100vh - 140px);
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-composition-modal-bCQBLC .semi-modal-content {
  background-color: #f5f7fa;
  padding: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-composition-modal-bCQBLC .semi-modal-content .semi-modal-body {
  padding: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-composition-modal-bCQBLC .semi-modal-content .semi-modal-body::-webkit-scrollbar {
  display: none;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__composition-modal-layout-wOPq4M {
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-TEW1Or {
  background-color: #ebedf0;
  flex-direction: column;
  width: 218px;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-TEW1Or ::-webkit-scrollbar {
  display: none;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-TEW1Or .\\------packages-components-bot-semi-src-components-ui-modal-index-module__title-rTvEOw {
  color: #1c1f23;
  white-space: nowrap;
  padding: 24px;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-TEW1Or .\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-main-yr8EFi {
  flex: 1;
  padding: 34px 12px 0;
  overflow-y: auto;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-TEW1Or .\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-header-ewJUUJ {
  flex-direction: column;
  width: 100%;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-TEW1Or .\\------packages-components-bot-semi-src-components-ui-modal-index-module__aside-divider-nhZRMA {
  width: calc(100% - 24px);
  margin-left: 12px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__content-EksxB3 {
  background: #f7f7fa;
  flex-direction: column;
  flex: 1;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__content-EksxB3 .\\------packages-components-bot-semi-src-components-ui-modal-index-module__header-ybkMcv {
  box-sizing: border-box;
  justify-content: space-between;
  width: 100%;
  padding: 24px 24px 16px;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__content-EksxB3 .\\------packages-components-bot-semi-src-components-ui-modal-index-module__header-ybkMcv .\\------packages-components-bot-semi-src-components-ui-modal-index-module__close-btn-q5DLGD {
  height: 24px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__content-EksxB3 .\\------packages-components-bot-semi-src-components-ui-modal-index-module__header-ybkMcv.\\------packages-components-bot-semi-src-components-ui-modal-index-module__filter-empty-AZ1tmI {
  justify-content: flex-end;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__main-xAcHBk {
  flex-direction: column;
  flex: 1;
  display: flex;
  overflow: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__main-xAcHBk .\\------packages-components-bot-semi-src-components-ui-modal-index-module__main-header-EGJPk8 {
  width: 100%;
  margin-bottom: 8px;
  padding: 1px 36px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__main-content-OdYnE3 {
  flex: 1;
  padding: 0 24px;
  overflow: auto;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content {
  background-color: #f5f7fa;
  border: 0 solid rgba(0, 0, 0, .08);
  border-radius: 1.5rem;
  width: 18.5rem;
  min-height: 9.475rem;
  max-height: calc(100vh - 140px);
  margin: auto;
  padding: 1.5rem 1.5rem 1.25rem;
  position: relative;
  box-shadow: 0 7.7px 10.5px rgba(0, 0, 0, .2), 0 6.3px 32.2px rgba(0, 0, 0, .12), 0 16.8px 26.6px rgba(0, 0, 0, .14);
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-header {
  margin-top: 0;
  margin-bottom: .35rem;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-header .semi-modal-title {
  justify-content: center;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-body {
  text-align: center;
  min-height: 0;
  overflow: auto;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-body::-webkit-scrollbar {
  display: none;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-body.semi-modal-withIcon {
  margin-left: unset;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-footer {
  margin-top: 1rem;
  margin-bottom: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-footer div {
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-footer .semi-button {
  border: 1px solid rgba(29, 28, 35, .16);
  border-radius: 2.375rem;
  min-width: 7.25rem;
  margin: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-content .semi-modal-footer .semi-button span {
  font-size: .875rem;
  font-weight: 600;
  line-height: 1.25rem;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-header .semi-button-with-icon-only {
  border-radius: 4px;
  height: 24px;
  padding: 4px !important;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-header .semi-button-with-icon-only svg {
  width: 16px;
  height: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-header .semi-button-with-icon-only.semi-button-borderless:not(.semi-button-disabled):hover {
  background: var(--light-usage-fill-color-fill-1, rgba(46, 46, 56, .08));
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc .semi-modal-header .semi-button-with-icon-only.semi-button-borderless:not(.semi-button-disabled):active {
  background: var(--light-usage-fill-color-fill-2, rgba(46, 46, 56, .12));
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r {
  width: 100%;
  min-width: 1280px;
  position: absolute;
  top: 0;
  left: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh {
  z-index: 1000;
  border: 1px solid var(--light-usage-border-color-border, rgba(28, 31, 35, .08));
  background: #f7f7fa;
  border-radius: 12px;
  flex-direction: column;
  min-height: 144px;
  max-height: calc(100vh - 140px);
  padding: 0 24px 24px;
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .1), 0 0 1px rgba(0, 0, 0, .3);
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-info-Q2RrEL {
  width: 446px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-small-KXyMue {
  width: 560px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-zRcsjo {
  width: 794px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh.\\------packages-components-bot-semi-src-components-ui-modal-index-module__modal-base-composition-HCwui9 {
  width: 1138px;
  height: calc(100vh - 140px);
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh.\\------packages-components-bot-semi-src-components-ui-modal-index-module__footer-custom-N1e9Z6 {
  padding-bottom: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-title-LD3o1b {
  color: var(--light-usage-text-color-text-0, #1c1f23);
  text-overflow: ellipsis;
  whitespace: nowrap;
  flex-shrink: 0;
  padding: 24px 0 16px;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-close-btn-M20wmY {
  position: absolute;
  top: 16px;
  right: 16px;
  color: var(--light-usage-text-color-text-0, #1c1d23) !important;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-content-LL8bwk {
  flex: 1;
  overflow: auto;
}

.\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh .\\------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-footer-SXjCq1 {
  flex-shrink: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-modal": `------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8`,
	"uiModal": `------packages-components-bot-semi-src-components-ui-modal-index-module__ui-modal-Aljgr8`,
	"show-scroll-bar": `------packages-components-bot-semi-src-components-ui-modal-index-module__show-scroll-bar-qdZHF3`,
	"showScrollBar": `------packages-components-bot-semi-src-components-ui-modal-index-module__show-scroll-bar-qdZHF3`,
	"modal-info": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-info-Q2RrEL`,
	"modalInfo": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-info-Q2RrEL`,
	"modal-action-small": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-small-KXyMue`,
	"modalActionSmall": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-small-KXyMue`,
	"modal-action": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-zRcsjo`,
	"modalAction": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-action-zRcsjo`,
	"modal-base-composition": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-base-composition-HCwui9`,
	"modalBaseComposition": `------packages-components-bot-semi-src-components-ui-modal-index-module__modal-base-composition-HCwui9`,
	"ui-composition-modal": `------packages-components-bot-semi-src-components-ui-modal-index-module__ui-composition-modal-bCQBLC`,
	"uiCompositionModal": `------packages-components-bot-semi-src-components-ui-modal-index-module__ui-composition-modal-bCQBLC`,
	"composition-modal-layout": `------packages-components-bot-semi-src-components-ui-modal-index-module__composition-modal-layout-wOPq4M`,
	"compositionModalLayout": `------packages-components-bot-semi-src-components-ui-modal-index-module__composition-modal-layout-wOPq4M`,
	"aside": `------packages-components-bot-semi-src-components-ui-modal-index-module__aside-TEW1Or`,
	"title": `------packages-components-bot-semi-src-components-ui-modal-index-module__title-rTvEOw`,
	"aside-main": `------packages-components-bot-semi-src-components-ui-modal-index-module__aside-main-yr8EFi`,
	"asideMain": `------packages-components-bot-semi-src-components-ui-modal-index-module__aside-main-yr8EFi`,
	"aside-header": `------packages-components-bot-semi-src-components-ui-modal-index-module__aside-header-ewJUUJ`,
	"asideHeader": `------packages-components-bot-semi-src-components-ui-modal-index-module__aside-header-ewJUUJ`,
	"aside-divider": `------packages-components-bot-semi-src-components-ui-modal-index-module__aside-divider-nhZRMA`,
	"asideDivider": `------packages-components-bot-semi-src-components-ui-modal-index-module__aside-divider-nhZRMA`,
	"content": `------packages-components-bot-semi-src-components-ui-modal-index-module__content-EksxB3`,
	"header": `------packages-components-bot-semi-src-components-ui-modal-index-module__header-ybkMcv`,
	"close-btn": `------packages-components-bot-semi-src-components-ui-modal-index-module__close-btn-q5DLGD`,
	"closeBtn": `------packages-components-bot-semi-src-components-ui-modal-index-module__close-btn-q5DLGD`,
	"filter-empty": `------packages-components-bot-semi-src-components-ui-modal-index-module__filter-empty-AZ1tmI`,
	"filterEmpty": `------packages-components-bot-semi-src-components-ui-modal-index-module__filter-empty-AZ1tmI`,
	"main": `------packages-components-bot-semi-src-components-ui-modal-index-module__main-xAcHBk`,
	"main-header": `------packages-components-bot-semi-src-components-ui-modal-index-module__main-header-EGJPk8`,
	"mainHeader": `------packages-components-bot-semi-src-components-ui-modal-index-module__main-header-EGJPk8`,
	"main-content": `------packages-components-bot-semi-src-components-ui-modal-index-module__main-content-OdYnE3`,
	"mainContent": `------packages-components-bot-semi-src-components-ui-modal-index-module__main-content-OdYnE3`,
	"ui-mobile-modal": `------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc`,
	"uiMobileModal": `------packages-components-bot-semi-src-components-ui-modal-index-module__ui-mobile-modal-tzqqDc`,
	"drag-modal": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r`,
	"dragModal": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-W2Z17r`,
	"drag-modal-wrapper": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh`,
	"dragModalWrapper": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-_paRVh`,
	"footer-custom": `------packages-components-bot-semi-src-components-ui-modal-index-module__footer-custom-N1e9Z6`,
	"footerCustom": `------packages-components-bot-semi-src-components-ui-modal-index-module__footer-custom-N1e9Z6`,
	"drag-modal-wrapper-title": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-title-LD3o1b`,
	"dragModalWrapperTitle": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-title-LD3o1b`,
	"drag-modal-wrapper-close-btn": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-close-btn-M20wmY`,
	"dragModalWrapperCloseBtn": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-close-btn-M20wmY`,
	"drag-modal-wrapper-content": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-content-LL8bwk`,
	"dragModalWrapperContent": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-content-LL8bwk`,
	"drag-modal-wrapper-footer": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-footer-SXjCq1`,
	"dragModalWrapperFooter": `------packages-components-bot-semi-src-components-ui-modal-index-module__drag-modal-wrapper-footer-SXjCq1`
};
export default ___CSS_LOADER_EXPORT___;
